import { render, staticRenderFns } from "./fuwu.vue?vue&type=template&id=74104646&scoped=true&"
import script from "./fuwu.vue?vue&type=script&lang=js&"
export * from "./fuwu.vue?vue&type=script&lang=js&"
import style0 from "./fuwu.vue?vue&type=style&index=0&id=74104646&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74104646",
  null
  
)

export default component.exports